/* nebe-ship.js — expediční slib. JEDEN výpočet pro dvě plochy: řádek na PDP a lišta v hlavičce.
 *
 * Proč zvlášť od nebe-pdp.js: lištu vidí zákazník na každé stránce, PDP engine se načítá jen
 * na detailu produktu. Modul je proto samostatný, bez závislostí a idempotentní — načtou ho
 * obě plochy a druhé načtení nesmí přepsat stav prvního.
 *
 * Texty modul NEOBSAHUJE napevno: čte je z window.NEBE_SHIP_I18N (locale soubory motivu,
 * emituje snippet nebe-ship-i18n.liquid). Vestavěný český FALLBACK je pojistka, aby se UI
 * nikdy nerozbilo, když klíč v locale chybí.
 *
 * DEBUG (stejná konvence jako ?d=mobile v nebe-pdp.js):
 *   ?ship=2026-12-23T13:50   přebije čas (bere se jako pražský nástěnný čas)
 *   ?country=SK              přebije trh (?country= prázdné = zahraničí)
 */
window.NEBE_SHIP = window.NEBE_SHIP || (function () {
  "use strict";

  // ---- konfigurace ----------------------------------------------------------------------
  var CUT_CZ = 14;        // uzávěrka pro ČR (GLS)
  var CUT_INTL = 11;      // uzávěrka pro všechno mimo ČR

  // Kdy se „do 14:00" překlopí na ubíhající čas. Výchozích 300 minut = od 9:00 ráno:
  // lišta má tikat celé dopoledne, ne až poslední čtyři hodiny.
  //
  // Hodnota je přebitelná zvenčí, protože o ní rozhoduje merchant v nastavení sekce, ne kód.
  // Čte se z NEBE_SHIP_CTX (emituje snippet nebe-ship-i18n.liquid) a ne z vlastního globálu:
  // kontext už tudy chodí a druhý globál by znamenal druhé místo, kde se dá zapomenout.
  var COUNTDOWN_MIN_DEFAULT = 300;
  function countdownMin() {
    var v = parseInt(ctx().countdownMin, 10);
    return isNaN(v) || v < 0 ? COUNTDOWN_MIN_DEFAULT : v;
  }

  // POZOR: tohle je FIREMNÍ kalendář, ne zákon. 24. a 31. 12. nejsou státní svátky, ale sklad
  // ten den nejede. Naopak kdyby přišla celozávodní dovolená, patří sem taky. Formát MM-DD.
  var HOLIDAYS_FIXED = [
    "01-01", // Nový rok
    "05-01", // Svátek práce
    "05-08", // Den vítězství
    "07-05", // Cyril a Metoděj
    "07-06", // Jan Hus
    "09-28", // Den české státnosti
    "10-28", // Vznik Československa
    "11-17", // Den boje za svobodu a demokracii
    "12-24", // Štědrý den — sklad nejede
    "12-25", // 1. svátek vánoční
    "12-26", // 2. svátek vánoční
    "12-31"  // Silvestr — sklad nejede
  ];
  // Velký pátek a Velikonoční pondělí jsou pohyblivé, počítají se z data Velikonoc.

  // Vánoční okna. Od 18. 12. přestáváme slibovat doručení (dopravci jsou zahlcení),
  // od 20. 12. do konce roku jede jednotný zmrazený text.
  var NO_DELIVERY_FROM = "12-18";
  var FREEZE_FROM = "12-20";

  // pole indexované getUTCDay() — díra na indexu 0 a 6 je záměr (víkend se sem nikdy nedostane)
  var DAY_KEY = [null, "ship_day_mon", "ship_day_tue", "ship_day_wed", "ship_day_thu", "ship_day_fri", null];

  var FALLBACK = {
    ship_by_time: "do %{time}",
    ship_by_hm: "během %{h}&nbsp;h %{m}&nbsp;min",
    ship_by_h: "během %{h}&nbsp;h",
    ship_by_min: "během %{m}&nbsp;min",
    // Vteřinové tvary pro lištu. Nedělitelná mezera je tu ZNAK, ne entita &nbsp; jako
    // o řádek výš: tenhle text sází paintDigits() po číslicích přes textContent, takže by
    // se entita v liště přečetla doslova.
    ship_by_hms: "během %{h} h %{m} min %{s} s",
    ship_by_ms: "během %{m} min %{s} s",
    ship_by_s: "během %{s} s",
    // %{it} = zájmeno podle toho, o čem se mluví. Když lišta nahoře slibuje „poslední
    // podprsenky", nemůže spodní řádek říkat „to máš zítra" — musí „je máš zítra".
    //
    // Dvě věty, ne jedna: „zítra" je v pátek sobota a to znamená GLS box, ne doručení domů.
    // Kterou z nich state() vybere, řídí kalendář — sem se znění jen dosazuje.
    ship_today_tomorrow: "objednej %{by} a zítra %{it} máš doma",
    ship_today_saturday: "objednej %{by} a zítra v sobotu %{it} máš v GLS boxu",
    ship_it_n: "to",
    ship_it_m: "ho",
    ship_it_f: "ji",
    ship_it_pl: "je",
    ship_today_only: "objednej %{by} a odesíláme ještě dnes",
    ship_next_tomorrow: "odesíláme ihned",
    ship_next_monday: "odesíláme hned v pondělí dopoledne",
    ship_day_mon: "odesíláme v pondělí ráno",
    ship_day_tue: "odesíláme v úterý ráno",
    ship_day_wed: "odesíláme ve středu ráno",
    ship_day_thu: "odesíláme ve čtvrtek ráno",
    ship_day_fri: "odesíláme v pátek ráno",
    ship_after_xmas: "odesíláme po Vánocích",
    ship_bar_prefix: "Objednávky "
  };

  // ---- čas: „fake-UTC nástěnné hodiny" --------------------------------------------------
  // Pražský čas rozložíme na čísla přes Intl a z nich složíme Date v UTC. Od té chvíle se
  // pracuje VÝHRADNĚ přes getUTC*/setUTC*, takže aritmetika dnů je imunní vůči letnímu času
  // i vůči pásmu prohlížeče — nikdy se nekonvertuje zpátky.
  var _dtf = null;
  function dtf() {
    if (!_dtf) {
      _dtf = new Intl.DateTimeFormat("en-CA", {
        timeZone: "Europe/Prague", hourCycle: "h23",
        year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit"
      });
    }
    return _dtf;
  }

  function pragueParts(d) {
    try {
      var parts = dtf().formatToParts(d), o = {};
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type !== "literal") o[parts[i].type] = parseInt(parts[i].value, 10);
      }
      // některé enginy vracejí o půlnoci hodinu „24" i s hourCycle:h23
      if (o.hour === 24) o.hour = 0;
      if (isNaN(o.year) || isNaN(o.hour)) throw new Error("bad parts");
      return o;
    } catch (e) {
      return manualPrague(d);
    }
  }

  // Záloha, když Intl s timeZone selže: EU pravidlo letního času (poslední neděle v březnu
  // 01:00 UTC → poslední neděle v říjnu 01:00 UTC). Nikdy nevracet null — volající počítá
  // s tím, že čas vždycky dostane.
  function lastSundayUTC(y, monthIndex) {
    var d = new Date(Date.UTC(y, monthIndex + 1, 0)); // poslední den měsíce
    d.setUTCDate(d.getUTCDate() - d.getUTCDay());
    d.setUTCHours(1, 0, 0, 0);
    return d;
  }
  function manualPrague(d) {
    var y = d.getUTCFullYear();
    var dst = d >= lastSundayUTC(y, 2) && d < lastSundayUTC(y, 9);
    var t = new Date(d.getTime() + (dst ? 2 : 1) * 3600000);
    return {
      year: t.getUTCFullYear(), month: t.getUTCMonth() + 1, day: t.getUTCDate(),
      hour: t.getUTCHours(), minute: t.getUTCMinutes()
    };
  }

  function wall(p) { return new Date(Date.UTC(p.year, p.month - 1, p.day)); }
  function addDays(dt, n) { var x = new Date(dt.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function mmdd(dt) { return pad(dt.getUTCMonth() + 1) + "-" + pad(dt.getUTCDate()); }

  // ---- kalendář -------------------------------------------------------------------------
  // Meeus/Jones/Butcher, memoizované per rok. Kontrola: 2026 → 5. 4., 2027 → 28. 3., 2028 → 16. 4.
  var _easter = {};
  function easter(y) {
    if (_easter[y]) return _easter[y];
    var a = y % 19, b = Math.floor(y / 100), c = y % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return (_easter[y] = new Date(Date.UTC(y, month - 1, day)));
  }

  function isHoliday(dt) {
    if (HOLIDAYS_FIXED.indexOf(mmdd(dt)) !== -1) return true;
    // rok bereme z předávaného data, ne z „dneška" — jinak by se přelom roku rozbil
    var e = easter(dt.getUTCFullYear()), t = dt.getTime();
    return t === addDays(e, -2).getTime() || t === addDays(e, 1).getTime();
  }
  function isWorkday(dt) {
    var w = dt.getUTCDay();
    return w >= 1 && w <= 5 && !isHoliday(dt);
  }
  function nextWorkday(dt) {
    for (var i = 1; i <= 21; i++) { // strop, ať překlep v kalendáři nevyrobí nekonečnou smyčku
      var x = addDays(dt, i);
      if (isWorkday(x)) return x;
    }
    return addDays(dt, 1);
  }
  function inXmasFreeze(dt) { var s = mmdd(dt); return s >= FREEZE_FROM && s <= "12-31"; }
  function inNoDelivery(dt) { var s = mmdd(dt); return s >= NO_DELIVERY_FROM && s <= "12-31"; }

  // ---- kontext (trh) --------------------------------------------------------------------
  function qparam(name) {
    try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; }
  }
  function ctx() { return window.NEBE_SHIP_CTX || {}; }

  // Pravidlo je binární: CZ = domácí, cokoli jiného = zahraničí. Není to seznam zemí.
  // Neznámá země padá do zahraničí, tedy do opatrnější větve bez slibu doručení.
  function isCZ() {
    var q = qparam("country");
    if (q !== null) return q.toUpperCase() === "CZ";
    var c = ctx().country;
    if (c) return c.toUpperCase() === "CZ";
    return ctx().currency === "CZK"; // fallback pro starší API verze bez localization.country
  }

  function overrideParts() {
    var q = qparam("ship");
    if (!q) return null;
    var m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})$/.exec(q);
    if (!m) return null;
    return { year: +m[1], month: +m[2], day: +m[3], hour: +m[4], minute: +m[5] };
  }

  // ---- výpočet stavu --------------------------------------------------------------------
  // Vrací STAV, ne hotový řetězec. Volající tak pozná, jestli se změnila věta (key) nebo jen
  // číslo v odpočtu — a na tom stojí celé řešení přístupnosti (viz renderStock v nebe-pdp.js).
  function state(nowParts) {
    var p = nowParts || overrideParts() || pragueParts(new Date());
    var today = wall(p);
    var cz = isCZ();
    var cutoff = cz ? CUT_CZ : CUT_INTL;
    var minsLeft = cutoff * 60 - (p.hour * 60 + p.minute);

    // vánoční zmrazení přebíjí všechno, i čas před uzávěrkou
    if (inXmasFreeze(today)) return { key: "ship_after_xmas", cutoff: cutoff, minsLeft: null, cz: cz };

    if (isWorkday(today) && minsLeft > 0) {
      // dočasný vypínač slibu doručení (NEBE_SHIP_CTX.promise_off === "1", locale ship_promise_off)
      var promise = cz && !inNoDelivery(today) && !promiseOff() && !dispatchOnly();
      var dow = today.getUTCDay();
      var key = "ship_today_only";
      if (promise && dow >= 1 && dow <= 4 && isWorkday(addDays(today, 1))) key = "ship_today_tomorrow";
      else if (promise && dow === 5) key = "ship_today_saturday";
      // cutoffAt = dnešní uzávěrka v absolutním čase. minsLeft je jen na minuty (pražské
      // části vteřiny neznají), a lišta potřebuje tikat po vteřinách — počítá si je proto
      // z tohohle okamžiku. Přes epochOf, takže ?ship=… ladí odpočet stejně jako slib.
      return {
        key: key, cutoff: cutoff, minsLeft: minsLeft, cz: cz,
        cutoffAt: epochOf({ year: p.year, month: p.month, day: p.day, hour: cutoff, minute: 0 })
      };
    }

    var nw = nextWorkday(today);
    var nextKey;
    // pořadí je podstatné: v neděli je pondělí zároveň „zítra", ale má znít „hned v pondělí"
    if (nw.getUTCDay() === 1) nextKey = "ship_next_monday";
    else if (nw.getTime() === addDays(today, 1).getTime()) nextKey = "ship_next_tomorrow";
    else nextKey = DAY_KEY[nw.getUTCDay()] || "ship_next_tomorrow";
    return { key: nextKey, cutoff: cutoff, minsLeft: null, cz: cz };
  }

  // ---- texty ----------------------------------------------------------------------------
  // Rozlišujeme dva různé důvody, proč text není:
  //   klíč CHYBÍ v locale (stará verze motivu) → český fallback, ať se UI nerozbije
  //   klíč je VYPRÁZDNĚNÝ v adminu             → vypínač, vracíme "" a volající to schová
  // Druhý případ je zavedená praxe téhle šablony (takhle se za expediční krize vypnul slib
  // a takhle je dodnes vypnutá atc_note) — nesmí se přebít fallbackem.
  function T(key, vars) {
    var src = window.NEBE_SHIP_I18N || {};
    var s = src[key];
    if (s == null || /translation missing/i.test(s)) s = FALLBACK[key];
    if (s == null || String(s).trim() === "") return "";
    if (vars) for (var k in vars) s = s.split("%{" + k + "}").join(vars[k]);
    return s;
  }

  // Prefix pro lištu smí být záměrně prázdný (angličtina ho nepotřebuje — „ships tomorrow"
  // dostane podmět z „Your order "), takže se nečte přes T(), které prázdno považuje za chybu.
  function barPrefix() {
    var src = window.NEBE_SHIP_I18N || {};
    var s = src.ship_bar_prefix;
    if (s == null || /translation missing/i.test(s)) s = FALLBACK.ship_bar_prefix;
    return s || "";
  }

  function byText(st, noCountdown, secsLeft) {
    if (st.minsLeft == null) return "";
    if (noCountdown || st.minsLeft > countdownMin()) return T("ship_by_time", { time: st.cutoff + ":00" });

    /* Vteřinová větev. Zapíná ji VÝHRADNĚ to, že volající dodá secsLeft — tedy lišta.
     * Řádek na PDP ho nepředává a zůstává na minutách: tikající vteřiny mezi „Skladem · "
     * a zbytkem věty by braly pozornost celému detailu produktu a hlavně by při každé
     * vteřině přepisovaly celý odstavec (lišta na to má vlastní slot s mřížkou číslic).
     *
     * Počítá se po CELÝCH vteřinách, ne po setinách: slib expedice není kampaňový odpočet,
     * má odtikávat klidně, ne blikat.
     */
    if (secsLeft != null) {
      var left = Math.max(0, Math.floor(secsLeft));
      var sh = Math.floor(left / 3600), sm = Math.floor(left / 60) % 60, ss = left % 60;
      // Minuty i vteřiny dvoumístně, jakmile mají nad sebou vyšší jednotku — jinak by se
      // text při přeskoku přes desítku zkrátil o znak a věta by poskočila.
      if (sh > 0) return T("ship_by_hms", { h: sh, m: pad(sm), s: pad(ss) });
      if (sm > 0) return T("ship_by_ms", { m: sm, s: pad(ss) });
      return T("ship_by_s", { s: pad(ss) });
    }

    var h = Math.floor(st.minsLeft / 60), m = st.minsLeft % 60;
    if (h === 0) return T("ship_by_min", { m: m });
    if (m === 0) return T("ship_by_h", { h: h });
    return T("ship_by_hm", { h: h, m: m });
  }

  // Zájmeno pro %{it}. Rod se NEHÁDÁ z názvu produktu — to by dřív nebo později vyrobilo
  // nesmysl. Nastavuje se ručně tam, kde se ví, o čem řeč (lišta), jinak zůstane obecné „to".
  // Angličtina rod nemá, takže tam všechny varianty krom množného čísla vracejí „it".
  function pronoun(kind) {
    var key = "ship_it_" + (kind || "n");
    var s = T(key);
    return s || T("ship_it_n") || "to";
  }

  /* text({surface, state, now, noCountdown, pronoun, secsLeft, bySlot}) → hotová věta
   *   surface: "pdp" (výchozí) = pokračování za „Skladem · ", malé písmeno, bez podmětu
   *            "bar"           = samostatná věta, odložené stavy dostanou podmět
   *   noCountdown: vynutí „do 14:00" místo tikajícího čísla — pro čtečku obrazovky
   *   pronoun: "n" | "m" | "f" | "pl" — rod a číslo zboží, o kterém se mluví
   *   secsLeft: zbývající vteřiny do uzávěrky; JEN pro lištu, viz byText()
   *   bySlot: místo časového údaje se do věty vloží tenhle řetězec. Lišta si tím vyzvedne
   *           kostru věty a na označené místo pak posadí <span>, do kterého sype číslice —
   *           přepisovat kvůli vteřině celý odstavec by bylo drahé i vidět.
   */
  // Dočasný vypínač všech expedičních slibů (locale ship_promise_off = "1", viz nebe-ship-i18n):
  // žádné „zítra to máš doma", ani „odesíláme ještě dnes" / „ihned". Prázdná věta = řádek zmizí.
  // Hodnota "cz" = slibuje se jen odeslání ("odesíláme ještě dnes", ne "zítra máš doma") a jen
  // na českém trhu; mimo ČR zůstává řádek prázdný.
  function promiseMode() {
    return String((window.NEBE_SHIP_CTX || {}).promise_off || "").trim().toLowerCase();
  }
  function dispatchOnly() { return promiseMode() === "cz"; }
  function promiseOff() {
    var m = promiseMode();
    return m === "1" || (m === "cz" && !isCZ());
  }

  function text(opts) {
    if (promiseOff()) return "";
    opts = opts || {};
    var st = opts.state || state(opts.now);
    var hasCountdownSlot = st.minsLeft != null;
    var vars = { it: pronoun(opts.pronoun) };
    if (hasCountdownSlot) {
      vars.by = opts.bySlot != null ? opts.bySlot : byText(st, opts.noCountdown, opts.secsLeft);
    }
    /* Lišta smí mít pro dobu před uzávěrkou vlastní znění: slibuje se v ní něco jiného než
     * v řádku na PDP (odeslání versus doručení) a to znění se zrovna ladí. Klíč je proto
     * NEPOVINNÝ a nemá zálohu v FALLBACK — kdyby ji měl, bylo by znění zadrátované v kódu
     * a přepnout ho by znamenalo deploy. Prázdný nebo chybějící klíč = lišta říká totéž
     * co detail produktu, tedy původní chování.
     */
    var body = "";
    if (opts.surface === "bar" && hasCountdownSlot) body = T("ship_bar_today", vars);
    if (!body) body = T(st.key, vars);
    if (!body) return "";
    // podmět potřebují jen odložené stavy („odesíláme…"); věty s „objednej…" ho mají v sobě
    if (opts.surface === "bar" && !hasCountdownSlot) body = barPrefix() + body;
    return body;
  }

  // ---- jeden časovač pro obě plochy ------------------------------------------------------
  // Běží POŘÁD, ne jen během odpočtu. Zákazník nechá tab otevřený hodiny a text se musí
  // překlopit sám ve třech okamžicích: v 9:00 naskočí odpočet, ve 14:00 padne slib,
  // o půlnoci se „zítra" stane „dneškem". Kdyby se časovač zapínal jen k odpočtu, po 14:00
  // by se vypnul a stránka by o půlnoci zamrzla na včerejším textu.
  //
  // Jeden časovač pro PDP i lištu je záměr: obě plochy se tak překlopí naráz a nemůžou si
  // odporovat. Odběratel vrátí false, když už ho není třeba (odpojený uzel).
  var _subs = [];
  var _started = false;

  function fire() {
    for (var i = _subs.length - 1; i >= 0; i--) {
      var keep = true;
      try { keep = _subs[i]() !== false; } catch (e) { keep = false; }
      if (!keep) _subs.splice(i, 1);
    }
  }
  function schedule() {
    // srovnání na hranici minuty (+ rezerva, ať Intl vidí novou minutu) → nulový drift
    // a samo se to srovná i po probuzení uspaného tabu
    setTimeout(function () {
      if (!document.hidden) fire();
      schedule();
    }, 60000 - (Date.now() % 60000) + 250);
  }
  function onMinute(cb) {
    _subs.push(cb);
    if (!_started) {
      _started = true;
      schedule();
      // tab mohl být uspaný hodinu a mezitím se mohly překlopit klidně dva z těch okamžiků
      document.addEventListener("visibilitychange", function () { if (!document.hidden) fire(); });
    }
    return function () {
      var i = _subs.indexOf(cb);
      if (i !== -1) _subs.splice(i, 1);
    };
  }

  // ---- jemný tik pro odpočty po setinách -------------------------------------------------
  // Druhý časovač vedle minutového: kampaňové odpočty (lišta v hlavičce, řádek pod cenou na PDP)
  // ukazují v posledních hodinách i vteřiny se setinami, aby byl termín vidět jako ubíhající čas.
  //
  // Motor je JEDEN pro všechny plochy ze stejného důvodu jako u minutového tiku: dva odpočty
  // na jedné stránce se nesmí rozejít, a hlavně se nemá platit dvěma smyčkami za totéž.
  //
  // Rozpočet na výkon (mobil hraje prim):
  //   * překresluje se nejvýš 30× za vteřinu, ne při každém snímku,
  //   * ve skrytém tabu smyčka stojí (rAF ji uspí sám, sekundový režim se odhlásí),
  //   * odběratel se dá navázat na element a mimo obrazovku se pak nekreslí vůbec,
  //   * když snímky soustavně nestíhají, celý motor se JEDNOSMĚRNĚ přepne na tikot po
  //     vteřinách — zpátky se nevrací, přepínání sem a tam by bylo nápadnější než sám tikot.
  // Kdo si v systému vypnul animace, dostane sekundový režim rovnou.
  var _fsubs = [];
  var _raf = null, _tmr = null, _lastTs = 0, _deltas = [];
  var _coarse = false;
  try {
    _coarse = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  } catch (e) {}

  function isCoarse() { return _coarse; }

  /* ---- hodiny snímku ---------------------------------------------------------------------
   * Setiny se nesmí počítat z Date.now() v okamžiku, kdy callback zrovna doběhne. Snímky jdou
   * po 16,67 ms, ale callback se spouští s rozptylem ±2 ms, a když fáze snímků sedí blízko
   * hranice setiny, rozptyl ji přeskakuje sem a tam: pravidelný rytmus kroků 2-2-1 setiny se
   * pak občas zlomí na 1-2-1 / 2-2-2 nebo 3-1-1. Na oku je to zadrhnutí, a podle toho, jak
   * padne fáze při načtení, klidně každých 0,8 s (naměřeno 24. 9. 2026 v Chrome na Macu:
   * snímky přesně 16,666 ms, zlomy rytmu jen z rozptylu Date.now()).
   *
   * Hodiny snímku proto jdou po PEVNÝCH krocích: každý snímek posune čas přesně o délku
   * snímku (u vynechaného snímku o celé násobky), takže rytmus setin je stroj. Délka snímku
   * se měří průměrem přes 30 snímků a přichytí se k běžné obnovovací frekvenci displeje;
   * se skutečným časem se hodiny srovnají skokem jen tehdy, když se rozejdou o víc než
   * 25 ms (uspaný tab, dlouhý zásek). */
  var _fclock = null, _fper = 0, _fwin = null;
  var _RATES = [30, 48, 50, 60, 72, 75, 90, 100, 120, 144, 165, 240];

  function _snapPeriod(p) {
    for (var i = 0; i < _RATES.length; i++) {
      var q = 1000 / _RATES[i];
      if (Math.abs(p - q) / q < 0.01) return q;
    }
    return p;
  }

  function _clockTick(ts) {
    var now = Date.now();
    // délka snímku: průměr přes okno 30 snímků bez výpadků
    if (!_fwin) _fwin = { ts: ts, n: 0, max: 0 };
    else {
      var d = ts - (_fclock ? _fclock.ts : ts);
      _fwin.n++;
      if (d > _fwin.max) _fwin.max = d;
      if (_fwin.n >= 30) {
        var avg = (ts - _fwin.ts) / _fwin.n;
        if (_fwin.max < avg * 1.5) _fper = _snapPeriod(avg);
        _fwin = { ts: ts, n: 0, max: 0 };
      }
    }
    if (!_fclock) { _fclock = { t: now, ts: ts }; return; }
    var per = _fper || 1000 / 60;
    var steps = Math.max(1, Math.round((ts - _fclock.ts) / per));
    var t = _fclock.t + steps * per;
    if (Math.abs(t - now) > 25) t = now;
    _fclock.t = t;
    _fclock.ts = ts;
  }

  // Čas pro kreslení odpočtu: v běžící smyčce hodiny snímku, jinak obyčejný Date.now().
  // (_fstop hodiny zahazuje, takže mimo smyčku se sem stará hodnota nedostane.)
  function frameNow() { return _fclock ? _fclock.t : Date.now(); }

  function _fstop() {
    if (_raf) { cancelAnimationFrame(_raf); _raf = null; }
    if (_tmr) { clearTimeout(_tmr); _tmr = null; }
    _lastTs = 0;
    _deltas.length = 0;
    _fclock = null;
    _fwin = null;
  }

  function _fpaint() {
    for (var i = _fsubs.length - 1; i >= 0; i--) {
      var sub = _fsubs[i];
      if (!sub.visible) continue;
      var keep = true;
      try { keep = sub.cb(_coarse) !== false; } catch (e) { keep = false; }
      if (!keep) { if (sub.io) sub.io.disconnect(); _fsubs.splice(i, 1); }
    }
    if (!_fsubs.length) _fstop();
  }

  function _frame(ts) {
    _raf = null;
    if (document.hidden || !_fsubs.length) return;

    // Zdraví smyčky se měří mediánem přes třicet snímků. Jeden dlouhý snímek nic neznamená
    // (dojezd scrollu, dekódování obrázku), soustavně dlouhé snímky ano.
    if (_lastTs) {
      _deltas.push(ts - _lastTs);
      if (_deltas.length >= 30) {
        var med = _deltas.slice().sort(function (a, b) { return a - b; })[15];
        _deltas.length = 0;
        if (med > 40 && !_coarse) { _coarse = true; _fstop(); _fstart(); return; }
      }
    }
    _lastTs = ts;
    _clockTick(ts);

    // Kreslí se KAŽDÝ snímek, bez zaškrcení. Původní strop 33 ms se při 60 Hz trefoval
    // střídavě do dvou a tří snímků (naměřeno 33 a 50 ms), a ta nepravidelnost je na
    // odpočtu vidět jako drobné zadrhávání. Práce navíc je jeden zápis do dvou číslic.
    _fpaint();
    if (_fsubs.length) _raf = requestAnimationFrame(_frame);
  }

  function _second() {
    _tmr = null;
    _fpaint();
    if (_fsubs.length) _fstart();
  }

  function _fstart() {
    if (_raf || _tmr || !_fsubs.length || document.hidden) return;
    if (_coarse) {
      // Probouzet se na hranici vteřiny, ne po celých vteřinách od načtení — jinak by
      // číslo občas přeskočilo o dvě, když se timer trefí těsně vedle hranice.
      _tmr = setTimeout(_second, 1000 - (Date.now() % 1000) + 15);
      return;
    }
    _raf = requestAnimationFrame(_frame);
  }

  /* Vykreslení čísla do pevné mřížky. Značkový font (Jost) NEMÁ tabulární číslice —
   * „11111" je v něm o dvanáct pixelů užší než „00000" — takže `font-variant-numeric`
   * nemá co zapnout a text by při každé setině měnil šířku. Celý vycentrovaný řádek
   * lišty by tím lítal do stran.
   *
   * Každá číslice proto sedí ve vlastní buňce široké `1ch` (= šířka nuly), zbytek textu
   * zůstává obyčejným textovým uzlem. Přepisují se jen ty buňky, kde se znak opravdu
   * změnil: u setin jsou to dvě za snímek, ne celý řetězec.
   *
   * Struktura se staví znovu jen tehdy, když se změní tvar (jiná délka nebo jiné pozice
   * číslic) — tedy při překlopení režimu, ne při tikání.
   */
  function _sameShape(a, b) {
    if (a == null || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      var ca = a.charCodeAt(i), cb = b.charCodeAt(i);
      var da = ca >= 48 && ca <= 57, db = cb >= 48 && cb <= 57;
      if (da !== db) return false;
      if (!da && ca !== cb) return false; // změnila se jednotka nebo oddělovač
    }
    return true;
  }

  function paintDigits(el, text) {
    if (!el) return;
    var prev = el._nbText;
    if (_sameShape(prev, text)) {
      var cells = el._nbCells;
      for (var i = 0; i < text.length; i++) {
        if (text.charAt(i) !== prev.charAt(i) && cells[i]) cells[i].textContent = text.charAt(i);
      }
      el._nbText = text;
      return;
    }

    var frag = document.createDocumentFragment();
    var cells2 = [];
    var buf = "";
    for (var j = 0; j < text.length; j++) {
      var ch = text.charAt(j), code = text.charCodeAt(j);
      if (code >= 48 && code <= 57) {
        if (buf) { frag.appendChild(document.createTextNode(buf)); buf = ""; }
        var cell = document.createElement("span");
        cell.className = "nebe-digit";
        cell.textContent = ch;
        frag.appendChild(cell);
        cells2[j] = cell;
      } else buf += ch;
    }
    if (buf) frag.appendChild(document.createTextNode(buf));
    el.textContent = "";
    el.appendChild(frag);
    el._nbCells = cells2;
    el._nbText = text;
  }

  var _fvis = false;
  /* onFrame(cb, {watch}) → stop()
   *   cb(coarse) se volá až 30× za vteřinu; coarse = true znamená „kresli bez setin".
   *   Vrátí-li false, odběratel se odhlásí (doběhlý odpočet, odpojený uzel).
   *   watch: element, na který je odpočet navázaný — mimo obrazovku se nekreslí.
   */
  function onFrame(cb, opts) {
    var sub = { cb: cb, visible: true, io: null };
    _fsubs.push(sub);

    var el = opts && opts.watch;
    if (el && window.IntersectionObserver) {
      sub.io = new IntersectionObserver(function (entries) {
        sub.visible = entries[entries.length - 1].isIntersecting;
        if (sub.visible) { _fpaint(); _fstart(); }
      });
      sub.io.observe(el);
    }

    if (!_fvis) {
      _fvis = true;
      // Ve skrytém tabu se nekreslí; po návratu musí být číslo správně dřív, než ho někdo přečte.
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) _fstop();
        else { _fpaint(); _fstart(); }
      });
    }
    _fstart();

    return function () {
      var i = _fsubs.indexOf(sub);
      if (i !== -1) _fsubs.splice(i, 1);
      if (sub.io) sub.io.disconnect();
      if (!_fsubs.length) _fstop();
    };
  }

  // Zbývající minuty do pražského nástěnného času. Vystaveno kvůli kampaňovému odpočtu na PDP:
  // ať se nepíšou druhé hodiny a hlavně ať obě věci měří TÝMŽ časem a týmž tikem.
  // Pozor: odčítají se nástěnné časy, takže přes přechod letního času by výsledek byl
  // o hodinu vedle. Pro kampaň v rámci jednoho režimu (léto/zima) je to bez následku.
  function minutesUntil(target) {
    if (!target) return null;
    var p = overrideParts() || pragueParts(new Date());
    var now = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute);
    var end = Date.UTC(target.year, target.month - 1, target.day, target.hour, target.minute);
    return Math.round((end - now) / 60000);
  }

  // Pražský nástěnný čas → absolutní čas v ms. Vystaveno kvůli odpočtu v promo řádku lišty:
  // ten tiká po setinách vteřiny a minutová granularita minutesUntil() mu nestačí.
  //
  // Zónový offset se nedopočítává z tabulek, ale změří se: rozdíl mezi skutečným časem a týmž
  // okamžikem složeným z pražských částí JE offset zóny. Zaokrouhlení na celé minuty odfiltruje
  // sekundy a milisekundy aktuální minuty (pragueParts je nezná), takže zbude čistý offset —
  // jinak by cíl seděl až o minutu vedle. Přes ?ship=… se tak dá odpočet ladit stejně jako slib.
  function epochOf(wallTime) {
    if (!wallTime) return null;
    // Jedno časové razítko pro obě měření a zaokrouhlení DOLŮ. Nástěnný čas je useknutý na
    // minuty, takže rozdíl je posun zóny + uplynulé vteřiny aktuální minuty. Math.round
    // tu dřív ve druhé půlce minuty přičetl celou minutu navíc: odpočet pak po načtení
    // v hh:mm:30+ ukazoval o minutu víc a na nulu dojel až v 0:00:59 místo 0:00:00.
    var nowMs = Date.now();
    var p = overrideParts() || pragueParts(new Date(nowMs));
    var nowWall = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute);
    var offset = Math.floor((nowMs - nowWall) / 60000) * 60000;
    return Date.UTC(wallTime.year, wallTime.month - 1, wallTime.day, wallTime.hour, wallTime.minute) + offset;
  }

  // "2026-08-31T00:00" → {year, month, day, hour, minute}; cokoli jiného → null
  function parseWall(str) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})$/.exec(String(str || "").trim());
    if (!m) return null;
    return { year: +m[1], month: +m[2], day: +m[3], hour: +m[4], minute: +m[5] };
  }

  return {
    state: state,
    text: text,
    promiseOff: promiseOff,
    // Vystaveno kvůli liště: ta si kostru věty vyzvedne přes text({bySlot}) jednou a pak
    // do slotu sype už jen tenhle časový údaj, aby se kvůli vteřině nepřepisoval odstavec.
    byText: byText,
    onMinute: onMinute,
    onFrame: onFrame,
    isCoarse: isCoarse,
    frameNow: frameNow,
    paintDigits: paintDigits,
    minutesUntil: minutesUntil,
    epochOf: epochOf,
    parseWall: parseWall,
    // vystaveno kvůli testům v konzoli a kvůli QA matici
    _internals: { isWorkday: isWorkday, isHoliday: isHoliday, nextWorkday: nextWorkday, easter: easter, pragueParts: pragueParts }
  };
})();
